export default "__VITE_ASSET__CNZjBksQ__"